(function () {
  "use strict";

  /* ---- Scoop cursor: show a filled scoop while the mouse is pressed ---- */
  function initScoopPressCursor() {
    if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;

    function showFilledScoop(event) {
      if (event.pointerType && event.pointerType !== "mouse" && event.pointerType !== "pen") return;
      document.documentElement.classList.add("dd-scoop-pressed");
    }

    function showEmptyScoop() {
      document.documentElement.classList.remove("dd-scoop-pressed");
    }

    document.addEventListener("pointerdown", showFilledScoop, true);
    document.addEventListener("pointerup", showEmptyScoop, true);
    document.addEventListener("pointercancel", showEmptyScoop, true);
    window.addEventListener("blur", showEmptyScoop);
  }
  initScoopPressCursor();

  /* ---- Product CTAs: always open product pages at the gallery ---- */
  function initProductCtaTopNavigation() {
    var storageKey = "dd-product-page-top";

    function scrollProductToTop() {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }

    var pendingPath = "";
    try {
      pendingPath = window.sessionStorage.getItem(storageKey) || "";
    } catch (error) {}

    if (pendingPath && pendingPath === window.location.pathname) {
      try {
        window.sessionStorage.removeItem(storageKey);
      } catch (error) {}

      var previousScrollRestoration = "auto";
      if ("scrollRestoration" in window.history) {
        previousScrollRestoration = window.history.scrollRestoration;
        window.history.scrollRestoration = "manual";
      }

      scrollProductToTop();
      window.requestAnimationFrame(scrollProductToTop);
      window.addEventListener("load", scrollProductToTop, { once: true });
      window.setTimeout(function () {
        scrollProductToTop();
        if ("scrollRestoration" in window.history) {
          window.history.scrollRestoration = previousScrollRestoration;
        }
      }, 250);
    }

    document.addEventListener("click", function (event) {
      var link = event.target.closest("a[href]");
      if (!link) return;

      var label = (link.textContent || "").replace(/\s+/g, " ").trim();
      var isDellaProductCta = link.matches(
        "[data-dd-hero-cta], [data-dd-final-cta-link], .dd-science__cta a, .dd-review-cta__button"
      );
      var hasShopLabel = /^(shop now|shop the powder|shop della daily|explore the product|try it now)$/i.test(label);
      if (!isDellaProductCta && !hasShopLabel) return;

      var destination;
      try {
        destination = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (destination.origin !== window.location.origin || destination.pathname.indexOf("/products/") === -1) return;

      destination.hash = "";
      link.href = destination.pathname + destination.search;

      try {
        window.sessionStorage.setItem(storageKey, destination.pathname);
      } catch (error) {}

      if (destination.pathname === window.location.pathname && destination.search === window.location.search) {
        event.preventDefault();
        try {
          window.sessionStorage.removeItem(storageKey);
        } catch (error) {}
        window.history.replaceState(window.history.state, "", destination.pathname + destination.search);
        scrollProductToTop();
      }
    });
  }
  initProductCtaTopNavigation();

  /* ---- Science carousel: center mobile arrows on the active media ---- */
  function initScienceArrowAlignment(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var widgets = Array.prototype.slice.call(scope.querySelectorAll("[data-dd-science-widget]"));
    if (scope.matches && scope.matches("[data-dd-science-widget]")) widgets.unshift(scope);

    widgets.forEach(function (widget) {
      if (widget.dataset.ddScienceArrowAlignment === "true") return;
      widget.dataset.ddScienceArrowAlignment = "true";

      var viewport = widget.querySelector("[data-dd-science-viewport]");
      if (!viewport) return;
      var frame = null;

      function positionArrows() {
        frame = null;
        if (!window.matchMedia("(max-width: 760px)").matches) {
          viewport.style.removeProperty("--dd-science-mobile-arrow-top");
          return;
        }

        var activePanel = widget.querySelector("[data-dd-science-panel].is-active:not([hidden])");
        var media = activePanel ? activePanel.querySelector(".dd-science__media") : null;
        if (!media) return;

        var viewportBox = viewport.getBoundingClientRect();
        var mediaBox = media.getBoundingClientRect();
        var center = mediaBox.top - viewportBox.top + mediaBox.height / 2;
        viewport.style.setProperty("--dd-science-mobile-arrow-top", center + "px");
      }

      function queuePosition() {
        if (frame) window.cancelAnimationFrame(frame);
        frame = window.requestAnimationFrame(positionArrows);
      }

      var panelObserver = new MutationObserver(queuePosition);
      panelObserver.observe(viewport, {
        subtree: true,
        attributes: true,
        attributeFilter: ["class", "hidden"],
      });

      if ("ResizeObserver" in window) {
        var sizeObserver = new ResizeObserver(queuePosition);
        sizeObserver.observe(viewport);
        viewport.querySelectorAll(".dd-science__media").forEach(function (media) {
          sizeObserver.observe(media);
        });
      }

      viewport.querySelectorAll("img").forEach(function (image) {
        if (!image.complete) image.addEventListener("load", queuePosition, { once: true });
      });
      viewport.querySelectorAll("video").forEach(function (video) {
        video.addEventListener("loadedmetadata", queuePosition, { once: true });
      });
      window.addEventListener("resize", queuePosition, { passive: true });
      queuePosition();
    });
  }

  initScienceArrowAlignment(document);
  window.addEventListener("load", function () { initScienceArrowAlignment(document); });
  document.addEventListener("shopify:section:load", function (event) {
    initScienceArrowAlignment(event.target);
  });

  /* ---- Optional sticky announcement bar ---- */
  function initStickyAnnouncementBars(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = Array.prototype.slice.call(scope.querySelectorAll(".dd-site-header-section--sticky-announcement"));
    if (scope.matches && scope.matches(".dd-site-header-section--sticky-announcement")) sections.unshift(scope);

    sections.forEach(function (section) {
      if (section.dataset.ddStickyAnnouncementReady === "true") return;
      section.dataset.ddStickyAnnouncementReady = "true";
      var bar = section.querySelector(".announcement-bar");
      if (!bar) return;

      function updateAnnouncementHeight() {
        section.style.setProperty("--dd-announcement-sticky-height", bar.offsetHeight + "px");
      }

      if ("ResizeObserver" in window) {
        new ResizeObserver(updateAnnouncementHeight).observe(bar);
      }
      window.addEventListener("resize", updateAnnouncementHeight, { passive: true });
      updateAnnouncementHeight();
    });
  }

  initStickyAnnouncementBars(document);
  document.addEventListener("shopify:section:load", function (event) {
    initStickyAnnouncementBars(event.target);
  });

  /* ---- Stacking discount helpers ----
     Tiers come from snippets/dd-tier-config.liquid via data-dd-tiers ("2:10,3:15").
     Display only: the real discount is applied by Shopify automatic discounts. */
  function ddParseTiers(raw) {
    return String(raw || "")
      .split(",")
      .map(function (pair) {
        var parts = pair.split(":");
        return { min: parseInt(parts[0], 10), pct: parseFloat(parts[1]) };
      })
      .filter(function (tier) { return tier.min > 0 && tier.pct > 0; })
      .sort(function (a, b) { return a.min - b.min; });
  }

  function ddTierPercent(tiers, qty) {
    var pct = 0;
    tiers.forEach(function (tier) { if (qty >= tier.min) pct = tier.pct; });
    return pct;
  }

  function ddNextTier(tiers, qty) {
    for (var i = 0; i < tiers.length; i++) { if (qty < tiers[i].min) return tiers[i]; }
    return null;
  }

  function ddTierSaving(regularCents, pct) {
    return Math.floor(regularCents * pct / 100);
  }

  function ddProgressMessage(tiers, qty) {
    if (!tiers.length) return "";
    var first = tiers[0];
    var top = tiers[tiers.length - 1];
    var current = ddTierPercent(tiers, qty);
    var next = ddNextTier(tiers, qty);
    var needed = next ? next.min - qty : 0;
    if (qty <= 0) return "Mix any " + first.min + " products to save " + first.pct + "%, " + top.min + " or more to save " + top.pct + "%.";
    if (!current) return "Add " + needed + " more " + (needed === 1 ? "product" : "products") + " to save " + next.pct + "%.";
    if (next) return current + "% off unlocked. Add " + needed + " more to save " + next.pct + "%.";
    return current + "% off unlocked on your routine.";
  }

  function ddRefreshQtyTiles(tiles) {
    var basePrice = parseInt(tiles.getAttribute("data-base-price-cents"), 10);
    if (!Number.isFinite(basePrice)) return;
    var currency = tiles.getAttribute("data-currency") || "USD";
    var tiers = ddParseTiers(tiles.getAttribute("data-dd-tiers"));
    var template = tiles.getAttribute("data-saving-template") || "Save __AMOUNT__";
    tiles.querySelectorAll("[data-qty]").forEach(function (tile) {
      var qty = parseInt(tile.getAttribute("data-qty"), 10) || 1;
      var regular = basePrice * qty;
      var pct = ddTierPercent(tiers, qty);
      var saving = ddTierSaving(regular, pct);
      var total = tile.querySelector(".dd-qty-tiles__total");
      var savingNode = tile.querySelector(".dd-qty-tiles__saving");
      if (total) total.textContent = formatBundleMoney(regular - saving, currency) + " total";
      if (savingNode && pct > 0) {
        savingNode.textContent = template.replace("__AMOUNT__", formatBundleMoney(saving, currency)) + " · " + pct + "% off";
      }
    });
  }

  /* ---- Purchase-option state and one-time bundle controls ---- */
  function formatBundleMoney(cents, currency) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en-US", {
        style: "currency",
        currency: currency || "USD",
      }).format(cents / 100);
    } catch (error) {
      return "$" + (cents / 100).toFixed(2);
    }
  }

  function ensureQtySelectionSummary(form) {
    if (!form) return null;
    var wrap = form.querySelector("[data-dd-qty-tiles]");
    if (!wrap) return null;

    var summary = wrap.querySelector("[data-dd-qty-selection-summary]");
    if (summary) return summary;

    summary = document.createElement("div");
    summary.className = "dd-qty-selection-summary";
    summary.setAttribute("data-dd-qty-selection-summary", "");
    summary.setAttribute("aria-live", "polite");
    summary.innerHTML =
      '<span class="dd-qty-selection-summary__label" data-dd-qty-summary-label>1 product selected</span>' +
      '<strong class="dd-qty-selection-summary__total" data-dd-qty-summary-total></strong>' +
      '<span class="dd-qty-selection-summary__saving" data-dd-qty-summary-saving hidden></span>';

    var row = wrap.querySelector(".dd-qty-tiles__row");
    if (row) row.insertAdjacentElement("afterend", summary);
    else wrap.appendChild(summary);
    return summary;
  }

  function updateProductBundlePrice(form, requestedQty) {
    if (!form) return;

    var meta = form.closest(".product-single__meta");
    var priceRoot = meta ? meta.querySelector(".product-block--price") : null;
    var mainPrice = priceRoot ? priceRoot.querySelector("[data-product-price]") : null;
    if (!priceRoot || !mainPrice) return;

    var tiles = form.querySelector("[data-dd-qty-tiles]");
    var selectedPlan = form.querySelector('[data-dd-selling-plans] input[name="selling_plan"]:checked');
    var subscriptionSelected = !!(selectedPlan && selectedPlan.value);
    var basePrice = parseInt((tiles && tiles.getAttribute("data-base-price-cents")) || priceRoot.getAttribute("data-base-price-cents"), 10);
    var currency = (tiles && tiles.getAttribute("data-currency")) || priceRoot.getAttribute("data-currency") || "USD";
    if (!Number.isFinite(basePrice)) return;

    priceRoot.setAttribute("data-dd-bundle-price", "");
    priceRoot.setAttribute("aria-live", "polite");

    var compare = priceRoot.querySelector("[data-dd-bundle-compare]");
    if (!compare) {
      compare = document.createElement("span");
      compare.className = "dd-bundle-price__compare";
      compare.setAttribute("data-dd-bundle-compare", "");
      compare.hidden = true;
      mainPrice.insertAdjacentElement("afterend", compare);
    }

    var saving = priceRoot.querySelector("[data-dd-bundle-saving]");
    if (!saving) {
      saving = document.createElement("span");
      saving.className = "dd-bundle-price__saving";
      saving.setAttribute("data-dd-bundle-saving", "");
      saving.hidden = true;
      saving.innerHTML = '<span data-dd-bundle-saving-copy>Save <span data-dd-bundle-saving-amount></span><span data-dd-saving-suffix></span></span>';
      compare.insertAdjacentElement("afterend", saving);
    }

    var renewal = priceRoot.querySelector("[data-dd-subscription-renewal]");
    if (!renewal) {
      renewal = document.createElement("span");
      renewal.className = "dd-subscription-renewal";
      renewal.setAttribute("data-dd-subscription-renewal", "");
      renewal.hidden = true;
      saving.insertAdjacentElement("afterend", renewal);
    }

    var qty = parseInt(requestedQty, 10) || 1;
    var selectedQtyTile = tiles ? tiles.querySelector('[data-qty="' + qty + '"]') : null;
    var tierPercent = tiles ? ddTierPercent(ddParseTiers(tiles.getAttribute("data-dd-tiers")), qty) : 0;
    var regularTotal = basePrice * qty;
    var displayTotal = Math.max(0, regularTotal - ddTierSaving(regularTotal, tierPercent));
    var discountPercent = regularTotal > displayTotal ? (regularTotal - displayTotal) * 100 / regularTotal : 0;
    var renewalPrice = 0;

    if (subscriptionSelected) {
      var subscriptionPrice = parseInt(selectedPlan.getAttribute("data-price-cents"), 10);
      var subscriptionStandardPrice = parseInt(selectedPlan.getAttribute("data-standard-price-cents"), 10);
      renewalPrice = parseInt(selectedPlan.getAttribute("data-renewal-price-cents"), 10);
      displayTotal = Number.isFinite(subscriptionPrice) ? subscriptionPrice : basePrice;
      regularTotal = Number.isFinite(subscriptionStandardPrice) ? subscriptionStandardPrice : basePrice;
      discountPercent = regularTotal > displayTotal ? Math.round((regularTotal - displayTotal) * 100 / regularTotal) : 0;
      qty = 1;
    }

    var hasBundleSaving = !subscriptionSelected && discountPercent > 0;
    var hasSubscriptionSaving = subscriptionSelected && regularTotal > displayTotal;
    var hasSaving = hasBundleSaving || hasSubscriptionSaving;

    mainPrice.textContent = formatBundleMoney(displayTotal, currency);
    mainPrice.classList.toggle("on-sale", hasSaving);

    var percent = priceRoot.querySelector("[data-dd-bundle-percent]");
    var savingAmount = priceRoot.querySelector("[data-dd-bundle-saving-amount]");
    var savingSuffix = priceRoot.querySelector("[data-dd-saving-suffix]");

    if (compare) {
      compare.hidden = !hasSaving;
      compare.textContent = hasSaving ? formatBundleMoney(regularTotal, currency) : "";
    }
    if (saving) saving.hidden = !hasSaving;
    if (percent) {
      percent.textContent = hasSubscriptionSaving ? "Subscription deal" : hasBundleSaving ? "Bundle savings" : "";
    }
    if (savingAmount) {
      savingAmount.textContent = hasSaving ? formatBundleMoney(regularTotal - displayTotal, currency) : "";
    }
    if (savingSuffix) savingSuffix.textContent = hasSubscriptionSaving ? " today" : "";
    if (renewal) {
      var renewalSaving = Number.isFinite(renewalPrice) ? Math.max(0, basePrice - renewalPrice) : 0;
      renewal.hidden = !hasSubscriptionSaving || !Number.isFinite(renewalPrice);
      renewal.textContent = renewal.hidden
        ? ""
        : "Then " + formatBundleMoney(renewalPrice, currency) + " every 30 days · Save " + formatBundleMoney(renewalSaving, currency) + " per delivery";
    }

    priceRoot.classList.toggle("is-bundle-price", hasBundleSaving);
    priceRoot.classList.toggle("is-subscription-deal", hasSubscriptionSaving);

    var localSummary = ensureQtySelectionSummary(form);
    if (localSummary) {
      localSummary.hidden = subscriptionSelected;
      if (!subscriptionSelected) {
        var summaryLabel = localSummary.querySelector("[data-dd-qty-summary-label]");
        var summaryTotal = localSummary.querySelector("[data-dd-qty-summary-total]");
        var summarySaving = localSummary.querySelector("[data-dd-qty-summary-saving]");
        var selectedName = selectedQtyTile ? selectedQtyTile.querySelector(".dd-qty-tiles__name") : null;

        if (summaryLabel) {
          summaryLabel.textContent = ((selectedName && selectedName.textContent.trim()) || (qty + " selected")) + " selected";
        }
        if (summaryTotal) summaryTotal.textContent = formatBundleMoney(displayTotal, currency);
        if (summarySaving) {
          summarySaving.hidden = !hasBundleSaving;
          summarySaving.textContent = hasBundleSaving
            ? "Regular " + formatBundleMoney(regularTotal, currency) + " · Save " + formatBundleMoney(regularTotal - displayTotal, currency)
            : "";
        }
      }
    }
  }

  function setProductQuantity(wrap, qty) {
    var section = wrap.closest(".product-section");
    var qtyInput = section ? section.querySelector('input[name="quantity"]') : null;
    if (!qtyInput) return;
    qtyInput.value = qty;
    qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
    qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function syncPurchaseOptionUI(group) {
    var selected = group.querySelector('input[name="selling_plan"]:checked');
    group.querySelectorAll(".dd-selling-plan").forEach(function (option) {
      option.classList.toggle("is-selected", !!selected && option.contains(selected));
    });

    var form = group.closest("form");
    var tiles = form ? form.querySelector("[data-dd-qty-tiles]") : null;
    var subscriptionSelected = !!(selected && selected.value);

    if (tiles) {
      tiles.hidden = subscriptionSelected;
      tiles.style.display = subscriptionSelected ? "none" : "";

      if (subscriptionSelected) {
        tiles.querySelectorAll("[data-qty]").forEach(function (tile) {
          var isOneTub = tile.getAttribute("data-qty") === "1";
          tile.classList.toggle("is-selected", isOneTub);
          tile.setAttribute("aria-pressed", isOneTub ? "true" : "false");
        });
        setProductQuantity(tiles, 1);
      }
    }

    var selectedTile = tiles ? tiles.querySelector("[data-qty].is-selected") : null;
    var selectedQty = subscriptionSelected ? 1 : parseInt(selectedTile && selectedTile.getAttribute("data-qty"), 10) || 1;
    updateProductBundlePrice(form, selectedQty);

    var meta = group.closest(".product-single__meta");
    var nativeQuantity = meta ? meta.querySelector(".product__quantity") : null;
    if (nativeQuantity) {
      nativeQuantity.hidden = true;
      nativeQuantity.style.display = "none";
    }
  }

  document.addEventListener("change", function (event) {
    var input = event.target.closest('[data-dd-selling-plans] input[name="selling_plan"]');
    if (!input) return;
    syncPurchaseOptionUI(input.closest("[data-dd-selling-plans]"));
  });

  /* ---- Default to the subscription option on page load ---- */
  function selectSubscriptionByDefault() {
    document.querySelectorAll("[data-dd-selling-plans]").forEach(function (group) {
      var subRadio = group.querySelector('.dd-selling-plan--subscription input[type="radio"]');
      if (!subRadio) return;
      if (!subRadio.checked) {
        subRadio.checked = true;
      }
      syncPurchaseOptionUI(group);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", selectSubscriptionByDefault);
  } else {
    selectSubscriptionByDefault();
  }
  document.addEventListener("shopify:section:load", selectSubscriptionByDefault);

  /* ---- "Select Quantity" tub tiles (1 / 2 / 3) ----
     Markup lives in snippets/product-form.liquid, right above the
     purchase-option cards. This wires each tile to the real quantity
     input while Shopify applies the matching automatic quantity discount. */
  function initQtyTiles() {
    document.querySelectorAll("[data-dd-qty-tiles]").forEach(function (wrap) {
      if (wrap.dataset.ddQtyTilesBound) return;
      wrap.dataset.ddQtyTilesBound = "true";

      var meta = wrap.closest(".product-single__meta");
      var nativeQuantity = meta ? meta.querySelector(".product__quantity") : null;
      if (nativeQuantity) {
        nativeQuantity.hidden = true;
        nativeQuantity.style.display = "none";
      }

      var group = wrap.closest("form") ? wrap.closest("form").querySelector("[data-dd-selling-plans]") : null;
      if (group) syncPurchaseOptionUI(group);

      ensureQtySelectionSummary(wrap.closest("form"));

      var tiles = wrap.querySelectorAll("[data-qty]");
      tiles.forEach(function (tile) {
        tile.addEventListener("click", function () {
          var qty = parseInt(tile.getAttribute("data-qty"), 10);
          tiles.forEach(function (t) {
            var active = t === tile;
            t.classList.toggle("is-selected", active);
            t.setAttribute("aria-pressed", active ? "true" : "false");
          });
          setProductQuantity(wrap, qty);
          updateProductBundlePrice(wrap.closest("form"), qty);
        });
      });

      var initialTile = wrap.querySelector("[data-qty].is-selected");
      updateProductBundlePrice(wrap.closest("form"), parseInt(initialTile && initialTile.getAttribute("data-qty"), 10) || 1);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initQtyTiles);
  } else {
    initQtyTiles();
  }
  document.addEventListener("shopify:section:load", initQtyTiles);

  document.addEventListener("variant:change", function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !Number.isFinite(Number(variant.price))) return;

    window.setTimeout(function () {
      document.querySelectorAll("[data-dd-qty-tiles]").forEach(function (tiles) {
        tiles.setAttribute("data-base-price-cents", variant.price);
        ddRefreshQtyTiles(tiles);
        var form = tiles.closest("form");
        if (!form) return;
        var tile = form.querySelector("[data-dd-qty-tiles] [data-qty].is-selected");
        updateProductBundlePrice(form, parseInt(tile && tile.getAttribute("data-qty"), 10) || 1);
      });
    }, 0);
  });

  /* ---- Marquee: mark ready once its section re-renders in the editor ---- */
  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-dd-marquee]").forEach(function (marquee) {
      marquee.classList.add("is-ready");
    });
  });

  /* ---- Product gallery height fix ----
     The theme's slideshow init uses Flickity's avoidReflow option, which
     freezes .flickity-viewport at a height measured before the real photo
     has sized itself. On some mobile widths that measurement lands on a
     near-zero value and never corrects itself, leaving a large blank gap
     between the photo and the buy box below it. This re-syncs the
     viewport's height to the actual selected slide whenever it might be
     stale. */
  function fixGalleryHeight() {
    document.querySelectorAll("[data-product-photos]").forEach(function (slider) {
      var viewport = slider.querySelector(".flickity-viewport");
      var selected = slider.querySelector(".product-main-slide.is-selected");
      if (!viewport || !selected) return;
      var h = selected.offsetHeight;
      if (h > 0 && Math.abs(viewport.offsetHeight - h) > 4) {
        viewport.style.height = h + "px";
      }
    });
  }
  window.addEventListener("load", fixGalleryHeight);
  window.addEventListener("resize", fixGalleryHeight);
  document.addEventListener("shopify:section:load", fixGalleryHeight);
  setTimeout(fixGalleryHeight, 500);
  setTimeout(fixGalleryHeight, 1500);

  /* ---- Sticky mobile add-to-cart bar: keep in sync with the main buy box ---- */
  var stickyCleanup = null;
  function initStickyProductBar() {
    if (stickyCleanup) {
      stickyCleanup();
      stickyCleanup = null;
    }
    var sticky = document.querySelector("[data-dd-sticky-bar]");
    var productSection = document.querySelector(".template-product .product-section");
    if (!sticky || !productSection) return;

    var mainButton = productSection.querySelector("[data-add-to-cart]");
    var mainPrice = productSection.querySelector("[data-product-price]");
    var stickyButton = sticky.querySelector("[data-dd-sticky-submit]");
    var stickyText = sticky.querySelector("[data-dd-sticky-text]");
    var stickyPrice = sticky.querySelector("[data-dd-sticky-price]");
    var cartDrawer = document.getElementById("CartDrawer");
    if (!mainButton || !stickyButton) return;

    var mainButtonInView = true;
    var intersectionObserver = null;

    function drawerIsOpen() {
      return !!(
        (cartDrawer && (cartDrawer.classList.contains("drawer--is-open") || cartDrawer.getAttribute("aria-hidden") === "false")) ||
        document.documentElement.classList.contains("js-drawer-open") ||
        document.documentElement.classList.contains("js-drawer-open-cart") ||
        document.body.classList.contains("js-drawer-open") ||
        document.body.classList.contains("js-drawer-open-cart")
      );
    }

    function updateStickyVisibility() {
      var shouldHide = mainButtonInView || drawerIsOpen();
      if (sticky.hidden !== shouldHide) sticky.hidden = shouldHide;
    }

    function syncStickyBar() {
      if (stickyButton.disabled !== mainButton.disabled) stickyButton.disabled = mainButton.disabled;

      var mainText = mainButton.querySelector("[data-add-to-cart-text]");
      if (mainText && stickyText) {
        var nextText = mainText.textContent.trim();
        if (stickyText.textContent.trim() !== nextText) stickyText.textContent = nextText;
      }

      if (mainPrice && stickyPrice) {
        var nextPrice = mainPrice.textContent.trim();
        if (stickyPrice.textContent.trim() !== nextPrice) stickyPrice.textContent = nextPrice;
      }

      updateStickyVisibility();
    }

    function handleStickyClick() {
      syncStickyBar();
      if (!mainButton.disabled) mainButton.click();
    }
    stickyButton.addEventListener("click", handleStickyClick);

    function measureMainButton() {
      var bounds = mainButton.getBoundingClientRect();
      mainButtonInView =
        bounds.width > 0 &&
        bounds.height > 0 &&
        bounds.bottom > 0 &&
        bounds.top < window.innerHeight &&
        bounds.right > 0 &&
        bounds.left < window.innerWidth;
      updateStickyVisibility();
    }

    if ("IntersectionObserver" in window) {
      intersectionObserver = new IntersectionObserver(
        function (entries) {
          mainButtonInView = entries[0].isIntersecting;
          updateStickyVisibility();
        },
        { threshold: 0.2 }
      );
      intersectionObserver.observe(mainButton);
    } else {
      measureMainButton();
      window.addEventListener("scroll", measureMainButton, { passive: true });
      window.addEventListener("resize", measureMainButton);
    }

    var productObserver = new MutationObserver(syncStickyBar);
    productObserver.observe(productSection, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["disabled"],
    });

    var drawerObserver = new MutationObserver(updateStickyVisibility);
    if (cartDrawer) drawerObserver.observe(cartDrawer, { attributes: true, attributeFilter: ["class", "aria-hidden"] });
    drawerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    drawerObserver.observe(document.body, { attributes: true, attributeFilter: ["class"] });

    stickyCleanup = function () {
      stickyButton.removeEventListener("click", handleStickyClick);
      if (intersectionObserver) intersectionObserver.disconnect();
      productObserver.disconnect();
      drawerObserver.disconnect();
      window.removeEventListener("scroll", measureMainButton);
      window.removeEventListener("resize", measureMainButton);
    };

    syncStickyBar();
  }
  document.addEventListener("shopify:section:load", initStickyProductBar);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initStickyProductBar);
  } else {
    initStickyProductBar();
  }

  /* ---- Mobile nav: close the drawer after following a link ---- */
  function initMobileMenuAutoClose() {
    document.addEventListener("click", function (event) {
      var link = event.target.closest("#NavDrawer a[href]");
      if (!link) return;
      var href = link.getAttribute("href");
      if (!href || href === "#") return;
      var drawer = document.getElementById("NavDrawer");
      if (drawer) {
        var closeButton = drawer.querySelector(".js-drawer-close");
        if (closeButton) closeButton.click();
      }
    });
  }
  initMobileMenuAutoClose();

  /* ---- Mobile nav: swipe right to close ---- */
  function initMobileMenuSwipeClose() {
    var drawer = document.getElementById("NavDrawer");
    if (!drawer || drawer.dataset.ddSwipeCloseReady === "true") return;
    drawer.dataset.ddSwipeCloseReady = "true";

    var startX = 0;
    var startY = 0;
    var currentX = 0;
    var tracking = false;
    var horizontal = false;

    function resetInline(after) {
      window.setTimeout(function () {
        drawer.style.removeProperty("transform");
        drawer.style.removeProperty("transition");
        drawer.style.removeProperty("will-change");
        if (after) after();
      }, 190);
    }

    drawer.addEventListener("touchstart", function (event) {
      if (!event.touches || event.touches.length !== 1) return;
      startX = event.touches[0].clientX;
      startY = event.touches[0].clientY;
      currentX = startX;
      tracking = true;
      horizontal = false;
      drawer.style.setProperty("will-change", "transform");
    }, { passive: true });

    drawer.addEventListener("touchmove", function (event) {
      if (!tracking || !event.touches || event.touches.length !== 1) return;
      var x = event.touches[0].clientX;
      var y = event.touches[0].clientY;
      var dx = x - startX;
      var dy = y - startY;
      currentX = x;

      if (!horizontal) {
        if (Math.abs(dx) < 12) return;
        if (dx <= 0 || Math.abs(dx) <= Math.abs(dy) * 1.15) {
          tracking = false;
          drawer.style.removeProperty("will-change");
          return;
        }
        horizontal = true;
      }

      if (dx > 0) {
        event.preventDefault();
        var eased = Math.min(dx, drawer.getBoundingClientRect().width);
        drawer.style.setProperty("transition", "none", "important");
        drawer.style.setProperty("transform", "translate3d(" + eased + "px,0,0)", "important");
      }
    }, { passive: false });

    drawer.addEventListener("touchend", function () {
      if (!tracking && !horizontal) return;
      var dx = currentX - startX;
      var threshold = Math.min(90, drawer.getBoundingClientRect().width * 0.22);
      var closeButton = drawer.querySelector(".js-drawer-close");

      if (horizontal && dx >= threshold && closeButton) {
        drawer.style.setProperty("transition", "transform .18s ease", "important");
        drawer.style.setProperty("transform", "translate3d(100%,0,0)", "important");
        resetInline(function () { closeButton.click(); });
      } else if (horizontal) {
        drawer.style.setProperty("transition", "transform .18s ease", "important");
        drawer.style.setProperty("transform", "translate3d(0,0,0)", "important");
        resetInline();
      } else {
        drawer.style.removeProperty("will-change");
      }

      tracking = false;
      horizontal = false;
    }, { passive: true });

    drawer.addEventListener("touchcancel", function () {
      drawer.style.removeProperty("transform");
      drawer.style.removeProperty("transition");
      drawer.style.removeProperty("will-change");
      tracking = false;
      horizontal = false;
    }, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMobileMenuSwipeClose);
  } else {
    initMobileMenuSwipeClose();
  }

  /* ---- Della Daily multi-product routine progress ---- */
  var bundleProgressTimer = null;
  function getRoutineProductCount(cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    var progress = document.querySelector('[data-dd-eligible-products]');
    var eligible = progress ? progress.getAttribute('data-dd-eligible-products').split(',') : [];
    return cart.items.reduce(function (total, item) {
      if (item.gift_card || item.selling_plan_allocation || eligible.indexOf(String(item.product_id)) === -1) return total;
      return total + Math.max(0, Number(item.quantity) || 0);
    }, 0);
  }

  function updateBundleProgressNode(node, quantity) {
    var qty = Math.max(0, Number(quantity) || 0);
    var tiers = ddParseTiers(node.getAttribute("data-dd-tiers"));
    var top = tiers.length ? tiers[tiers.length - 1].min : 1;
    var current = ddTierPercent(tiers, qty);
    var fillQty = Math.min(qty, top);
    var fill = top > 1 && fillQty > 1 ? Math.round((fillQty - 1) * 100 / (top - 1)) : 0;

    node.setAttribute("data-qualifying-quantity", qty);
    node.setAttribute("data-state", qty >= top ? "complete" : current > 0 ? "tier-two" : "building");

    var messageNode = node.querySelector("[data-dd-progress-message]");
    var fillNode = node.querySelector("[data-dd-progress-fill]");
    if (messageNode) messageNode.textContent = ddProgressMessage(tiers, qty);
    if (fillNode) fillNode.style.width = fill + "%";

    node.querySelectorAll("[data-dd-progress-milestone]").forEach(function (milestone) {
      var threshold = parseInt(milestone.getAttribute("data-dd-progress-milestone"), 10);
      milestone.classList.toggle("is-unlocked", qty >= threshold);
    });
  }

  function updateBundleProgress(cart) {
    var qty = getRoutineProductCount(cart);
    document.querySelectorAll("[data-dd-bundle-progress]").forEach(function (node) {
      updateBundleProgressNode(node, qty);
    });
  }

  function fetchBundleProgress() {
    if (!document.querySelector("[data-dd-bundle-progress]")) return;
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
    fetch(root + "cart.js", {credentials:"same-origin",cache:"no-store",headers:{"X-Requested-With":"XMLHttpRequest"}})
      .then(function (response) { if (!response.ok) throw new Error("Unable to refresh routine progress"); return response.json(); })
      .then(updateBundleProgress)
      .catch(function () {});
  }

  function queueBundleProgress(cart) {
    window.clearTimeout(bundleProgressTimer);
    if (cart && Array.isArray(cart.items)) {
      updateBundleProgress(cart);
    }
    bundleProgressTimer = window.setTimeout(fetchBundleProgress, 140);
  }

  function initBundleProgress() {
    if (!document.querySelector("[data-dd-bundle-progress]")) return;
    document.querySelectorAll("[data-products]").forEach(function (products) {
      if (products.dataset.ddBundleProgressObserved) return;
      products.dataset.ddBundleProgressObserved = "true";
      new MutationObserver(function () { queueBundleProgress(); }).observe(products,{childList:true,subtree:true,characterData:true,attributes:true});
    });
    queueBundleProgress();
  }

  document.addEventListener("cart:updated", function (event) { queueBundleProgress(event.detail && event.detail.cart); });
  document.addEventListener("ajaxProduct:added", function () { queueBundleProgress(); });
  document.addEventListener("cart:build", function () { queueBundleProgress(); });
  document.addEventListener("drawerOpen", function () { queueBundleProgress(); });
  document.addEventListener("click", function (event) {
    if (!event.target.closest("#CartDrawer button, #CartDrawer a, .cart__item button, .cart__item a")) return;
    window.setTimeout(fetchBundleProgress, 220);
    window.setTimeout(fetchBundleProgress, 650);
  });
  document.addEventListener("change", function (event) {
    if (!event.target.closest("#CartDrawer input, #CartDrawer select, .cart__item input, .cart__item select")) return;
    window.setTimeout(fetchBundleProgress, 220);
    window.setTimeout(fetchBundleProgress, 650);
  });
  document.addEventListener("shopify:section:load", initBundleProgress);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initBundleProgress);
  else initBundleProgress();

  /* ---- Homepage product-slider navigation: always open PDP at the top ---- */
  function ddOpenProductAtTopIfRequested() {
    if (!document.body || !document.body.classList.contains("template-product")) return;
    var requested = "";
    try { requested = sessionStorage.getItem("ddOpenProductAtTop") || ""; } catch (e) {}
    if (!requested) return;
    try { sessionStorage.removeItem("ddOpenProductAtTop"); } catch (e) {}
    if ("scrollRestoration" in history) history.scrollRestoration = "manual";
    var forceTop = function () { window.scrollTo(0, 0); };
    forceTop();
    requestAnimationFrame(forceTop);
    window.setTimeout(forceTop, 80);
    window.setTimeout(forceTop, 260);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ddOpenProductAtTopIfRequested);
  } else {
    ddOpenProductAtTopIfRequested();
  }

  /* ---- Homepage lineup product links: open PDP at top ---- */
  document.addEventListener("click", function (event) {
    var link = event.target.closest("a[data-dd-product-top-link]");
    if (!link) return;
    var href = link.getAttribute("href");
    if (!href || href === "#") return;
    var cleanHref = href.split("#")[0];
    try { sessionStorage.setItem("ddOpenProductAtTop", cleanHref); } catch (e) {}
  });

})();

